import { KitDeletionArea } from "@/components/KitDeletionArea";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { AppTopRightMenu } from "@/components/app-layout/AppTopRightMenu";
import DisplayEditor from "@/components/display/display-editor/DisplayEditor";
import { GrantDialog } from "@/components/grant/GrantDialog";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export default function CollectionSettingsPage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { kit, updateKit } = useKitData(groupUuid, kitUuid);

  if (!kit || !groupUuid) {
    return null;
  }

  return (
    <>
      <AppTopRightMenu.ContentPortal display="append">
        <GrantDialog
          groupUuid={groupUuid}
          objectName={kit.name}
          kitUuid={kit.uuid}
        />
      </AppTopRightMenu.ContentPortal>
      <Page>
        <PageHeader>
          <PageHeader.Title>Collection Settings</PageHeader.Title>
        </PageHeader>
        <PageBody>
          <DisplayEditor
            name={kit.name}
            description={kit.description}
            onNameChange={(name) => updateKit({ name })}
            onDescriptionChange={(description) => updateKit({ description })}
          />

          <KitDeletionArea kit={kit} />
        </PageBody>
      </Page>
    </>
  );
}
